export const translateUserRole = (role) => {
  if (role === 'ADMIN') return '시스템관리자';
  if (role === 'SUB-ADMIN') return '관리자';
  if (role === 'CUSTOMER') return '유저관리자';
  return '유저';
};
